/* eslint-disable no-unused-vars */
/* eslint-disable import/order */
/* eslint-disable camelcase */
/* eslint-disable eqeqeq */
/* eslint-disable jsx-a11y/tabindex-no-positive */
import { Box, Grid, Tooltip } from '@material-ui/core'
import Button from '@material-ui/core/Button'
import withStyles from '@material-ui/core/styles/withStyles'
import Typography from '@material-ui/core/Typography'
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline'
import React, { Component, useEffect, useMemo, useState } from 'react'
import { connect, useDispatch, useSelector } from 'react-redux'
import { Link, Route, useLocation, useRouteMatch } from 'react-router-dom'
import { bindActionCreators } from 'redux'

import {
  mdiCurrencyUsd,
  mdiCurrencyUsdOff,
  mdiFileDocumentCheckOutline,
  mdiMonitor,
} from '@mdi/js'
import styles from '../../../resources/theme/global'
import { useQueryParams } from '../../../util/utils'
import { usePermissions } from '../../../hooks/usePermission'
import {
  bankStatement,
  clearFilter,
  fetchBilling,
  fetchBillingV2,
  getBillings,
} from '../BillingActions'
import { getBillingListData } from '../BillingReducer'

import Edit from './Edit'
import Filter from './Filter'
import List from './List'
import New from './New'
import CloseDetails from './CloseDetails'
import colors from '../../../assets/colors'
import Tabs from '../../../components/hooks/BaseTabs/Tabs'
import Tab from '../../../components/hooks/BaseTabs/Tab'
import { getPermission } from '../../attendance/AttendanceActions'

import BalanceList from './BalanceList'
import BankReportFilter from './BankReportFilter'
import BankStatement from './BankStatement'

import queryString from 'query-string'
import BaseCreatePage from '../../../components/hooks/BaseCreatePage'

import { useHistory } from 'react-router-dom/cjs/react-router-dom.min'
import Icon from '@mdi/react'
import { startOfMonth, endOfMonth } from 'date-fns'

const Billing = props => {
  // const { location } = props

  const items = useSelector(state => state.billing.items)
  const statement = useSelector(state => state.billing.bankStatement)
  const permissionUser = useSelector(state => state.auth.permissionUser)
  const permissions = useSelector(state => state.auth.permissions)
  const { canCreate, canRead, canUpdate } = usePermissions()

  const dispatch = useDispatch()

  const history = useHistory()
  const location = useLocation()
  const filters = useQueryParams(location.search)

  const currentTab = useMemo(() => {
    if (!filters?.tab) return 0
    return Number(filters?.tab)
  }, [location, filters])

  const origin = useMemo(() => {
    return filters?.origin || ''
  }, [location])

  const handleChangeTab = value => {
    history.push(`${location.pathname}?tab=${value}`)
  }

  const fetchBillings = () => {
    const tabFilters = {
      0: {
        type: 'Despesa',
        billing_type_generic: 'Despesa',
      },
      1: {
        type: 'Receita',
        billing_type_generic: 'Receita',
      },
    }

    const baseFilters = tabFilters[currentTab]

    const finalFilters = {
      ...filters,
      ...baseFilters,
    }

    dispatch(fetchBillingV2(finalFilters))
  }

  const fetchBanksBalance = () => {
    dispatch(bankStatement(filters))
    dispatch(fetchBillingV2({}))
  }

  const renderOrigin = origin => {
    const origins = {
      attendance: 'Atendimentos',
      oss: 'OSs de Parceiros',
      dashboardFinancial: 'Dashboard Leads',
    }

    return origins[origin] || 'Origem não reconhecida'
  }

  // Aplica o mês corrente como Data de Vencimento padrão (Despesa/Receita)
  // apenas quando a URL ainda não traz as chaves de data e não veio de um
  // contexto específico (service_id de atendimento/OS). Se o usuário limpou as
  // datas, o Filter envia a chave vazia e o default não é reaplicado.
  const applyDefaultDueDate = () => {
    const neverFilteredDueDate =
      filters?.initial_due_date === undefined &&
      filters?.final_due_date === undefined

    if (!neverFilteredDueDate || filters?.service_id) return false

    const searchParams = new URLSearchParams(location.search)
    searchParams.set('initial_due_date', startOfMonth(new Date()).toISOString())
    searchParams.set('final_due_date', endOfMonth(new Date()).toISOString())
    history.replace(`${location.pathname}?${searchParams.toString()}`)
    return true
  }

  useEffect(() => {
    if ([0, 1].includes(currentTab)) {
      if (!applyDefaultDueDate()) fetchBillings()
    } else if ([2].includes(currentTab)) {
      fetchBanksBalance()
    }
  }, [location])

  return (
    <>
      <Grid container spacing={2} alignItems="center">
        <Grid item xs={12}>
          <BaseCreatePage
            page="Financeiro"
            path="Lançamentos"
            pageLink="/billing"
            hiddenReturn
            goBack={Boolean(origin)}
          />
        </Grid>

        <Grid item xs={12}>
          {origin ? (
            <Box
              style={{
                borderTop: '1px',
                borderBottom: '1px',
                borderLeft: 0,
                borderRight: 0,
                borderStyle: 'dashed',
                borderColor: colors.graylight,
                color: colors.textGray,
                padding: '4px 0',
              }}
            >
              <Box
                style={{
                  display: 'flex',
                  gap: '8px',
                  alignItems: 'center',
                }}
              >
                <Icon path={mdiMonitor} size={1} />
                <span> {renderOrigin(origin)}.</span>
              </Box>
            </Box>
          ) : (
            <Tabs>
              <Tab
                label="Despesas"
                value={currentTab}
                tabIndex={0}
                setValue={handleChangeTab}
                icon={mdiCurrencyUsdOff}
                iconColor={colors.error}
                removeNavigation={false}
              />
              <Tab
                label="Receitas"
                value={currentTab}
                tabIndex={1}
                setValue={handleChangeTab}
                icon={mdiCurrencyUsd}
                iconColor={colors.sucess}
                removeNavigation={false}
              />
              <Tab
                label="Extrato Bancário"
                value={currentTab}
                setValue={handleChangeTab}
                tabIndex={2}
                icon={mdiFileDocumentCheckOutline}
                iconColor={colors.primary}
                removeNavigation={false}
              />
            </Tabs>
          )}
        </Grid>

        <Grid item xs={12}>
          {currentTab == 0 && (
            <Grid container spacing={3} style={{ marginTop: '4px' }}>
              <Grid item xs={12}>
                <Filter typeGeneric="Despesa" location={location} />
              </Grid>

              {canRead('lancamento-contas', permissionUser) && (
                <Grid item xs={12}>
                  <BalanceList
                    data={items || []}
                    permissions={permissions}
                    typeGeneric="Despesa"
                  />
                </Grid>
              )}
            </Grid>
          )}

          {currentTab == 1 && (
            <Grid container spacing={3} style={{ marginTop: '4px' }}>
              <Grid item xs={12}>
                <Filter typeGeneric="Receita" location={location} />
              </Grid>

              {canRead('lancamento-contas', permissionUser) && (
                <Grid item xs={12}>
                  <BalanceList
                    type="revenues"
                    permissions={permissions}
                    data={items || []}
                    typeGeneric="Receita"
                  />
                </Grid>
              )}
            </Grid>
          )}

          {currentTab == 2 && (
            <Grid container spacing={3} style={{ marginTop: '1em' }}>
              <Grid item xs={12}>
                <BankReportFilter />
              </Grid>

              <Grid item xs={12}>
                <BankStatement data={statement} />
              </Grid>
            </Grid>
          )}
        </Grid>
      </Grid>

      {canCreate('lancamento-contas', permissionUser) && (
        <Route path="/billing/new" component={New} />
      )}

      {canUpdate('lancamento-contas', permissionUser) && (
        <Route path="/billing/:id/edit" component={Edit} />
      )}

      {canRead('lancamento-contas', permissionUser) && (
        <Route path="/billing/:id/close" component={CloseDetails} />
      )}
    </>
  )
}

export default Billing
